import env from "@/env";

let API_URL = "";
let ROOT_URL = "";

if (process.env.envmode == "dev" || process.env.envmode == "development") {
  API_URL = env.API_DEV;
  ROOT_URL = env.ROOT_DEV;
} else if (process.env.envmode == "test") {
  API_URL = env.API_TEST;
  ROOT_URL = env.ROOT_DEV;
} else if (
  process.env.envmode == "prod" ||
  process.env.envmode == "production"
) {
  API_URL = env.API_PROD;
  ROOT_URL = env.ROOT_DEV;
}

export { API_URL };

export default {
  login: API_URL + "/user/login",

  register: API_URL + "/user/register",

  sendCode: API_URL + "/user/send_code",

  updateUser: API_URL + "/user/modify",

  userInfo: API_URL + "/user/info",

  forgotPassword: API_URL + "/user/forgot_password",

  changePassword: API_URL + "/user/change_password",

  toggleLanguage: API_URL + "/user/language",

  logout: API_URL + "/logout",

  captions: API_URL + "/captions",

  menu: API_URL + "/m/",

  banner: API_URL + "/banner",

  design: API_URL + "/design/get?web=1",

  captcha: API_URL + "/capcha",

  inquiry_create: API_URL + "/inquiry/create",

  schedule: {
    bus: API_URL + "/travel/country_bus",
    air: API_URL + "/travel/flight/",
    traffic: API_URL + "/travel/traffic_embedded",
    bus_lines: API_URL + "/travel/bus_lines",
    bus_line_detail: API_URL + "/travel/bus_line_detail/"
  },

  check_mta: API_URL + "/check_mta_account",

  card: API_URL + "/card",

  send_ebarimt: API_URL + "/card/send_ebarimt",

  newsTitles: API_URL + "/m/news_titles"
};
